__turbopack_context__.v({
  "buttonClose": "lockedFeaturePopupContent-module-scss-module__uLQ3LG__buttonClose",
  "container": "lockedFeaturePopupContent-module-scss-module__uLQ3LG__container",
  "description": "lockedFeaturePopupContent-module-scss-module__uLQ3LG__description",
  "icon": "lockedFeaturePopupContent-module-scss-module__uLQ3LG__icon",
  "title": "lockedFeaturePopupContent-module-scss-module__uLQ3LG__title",
});
